/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_Move_LaterInputs */

const cs_pipelines_move_later = /** @type {(inputs: Pipelines_Move_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posunout později`)
};

const en_pipelines_move_later = /** @type {(inputs: Pipelines_Move_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move later`)
};

/**
* | output |
* | --- |
* | "Move later" |
*
* @param {Pipelines_Move_LaterInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_move_later = /** @type {((inputs?: Pipelines_Move_LaterInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Move_LaterInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_move_later(inputs)
	return cs_pipelines_move_later(inputs)
});